import { bindAll } from 'lodash'
import View from 'view/view'
import Popover from 'component/popover/popover'
import communityChanger from 'component/community_changer'
import localcommunityTooltipTemplate from 'component/map/template/localcommunity_tooltip.tmpl'

const CommunityLinkView = View.extend({
    events: {
        'click .js-community-link-anchor': '_handleClick',
    },

    initialize() {
        bindAll(this, ['_handleClick'])

        const tooltip = this.$('.js-community-tooltip')

        this.initSubview(Popover, {
            content: localcommunityTooltipTemplate({
                marker: this.model.attributes,
                formatNumber: this._formatNumber,
            }),
            el: tooltip,
            name: 'Local Community',
            preset: 'tooltip',
        })
    },

    _formatNumber(num) {
        // format a number with grouped thousands
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    _handleClick() {
        communityChanger.change(this.$el.data())
    },
})

export default CommunityLinkView
